<template>
  <form @submit.prevent="search" @reset.prevent="resetForm">
    <b-row>
      <b-col md="3" class="mt-2" v-if="checkPermission(C_APPLICANT_FILTER_ECONOMY)">
        <label class="label-text">{{$t('ECONOMY')}}</label>
        <b-select :options="economyList"  v-model="filter.economy" value-field="id" text-field="name"></b-select>

      </b-col>
      <b-col md="3" class="mt-2" v-if="checkPermission(C_APPLICANT_FILTER_INSTITUTION)">
        <label class="label-text">{{$t('INSTITUTION')}}</label>
        <b-select :options="institutionList" v-model="filter.institution" value-field="id" text-field="name"></b-select>
      </b-col>
      <b-col md="3" class="mt-2">
        <label class="label-text">{{$t('DATE_RECEIPT_REQUEST')}}</label>
        <date-picker :placeholder="$t('FROM')" :value="filter.date_receipt_request_from" @change="dateReceptRequestFrom"></date-picker>
      </b-col>
      <b-col md="3" class="mt-4">
        <label class="label-text mt-4"></label>
        <date-picker :placeholder="$t('TO')" :value="filter.date_receipt_request_to" @change="dateReceptRequestTo"></date-picker>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3" class="">
        <label class="label-text">{{$t('FIRST_NAME_LAST_NAME')}}</label>
        <b-input  v-model="filter.name" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('PROTOCOL_NUMBER')}}</label>
        <b-input  v-model="filter.request_protocol_number" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('STUDIES_LEVEL')}}</label>
        <b-select :options="received_for_recognition"
                   type="select"
                   v-model="filter.study_level">
        </b-select>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('NAME_QUALIFICATION_IN_THE_ORIGINAL_LANGUAGE')}}</label>
        <b-input  v-model="filter.name_of_foreign_qualification" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('NAME_INSTITUTION_THAT_AWARDED_THE_QUALIFICATION')}}</label>
        <b-input  v-model="filter.name_awarding_institution_original_lang" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('SEAT_INSTITUION')}}</label>
        <b-input  v-model="filter.city_of_institution" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('ECONOMY')}}</label>
        <country v-model="filter.country" ></country>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('DECISION_PROTOCOL_NUMBER')}}</label>
        <b-input  v-model="filter.decision_protocol_number" type="text"></b-input>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('DECISION')}}</label>
        <b-select :options="options_decision_recognition"
                  type="select"
                  v-model="filter.decision_recognition">
        </b-select>
      </b-col>
      <b-col md="3" class="">
        <label class="label-text">{{$t('STATUS')}}</label>
        <b-select value-field="id" text-field="name" :options="statusList" v-model="filter.status" type="text"></b-select>
      </b-col>
      <b-col v-if="visibleTemporaryDecision" md="3" class="">
        <label class="label-text">{{$t('DECISION_TYPE')}}</label>
        <b-select value-field="value" text-field="text"   :options="decision_type_options" v-model="filter.decision_type" type="text"></b-select>
      </b-col>
    </b-row>
    <b-row class="mt-3">
    <b-col class="d-inline-flex">
      <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
      <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
    </b-col>
    </b-row>
  </form>
</template>

<script>
  import Country from '@/components/applicant/recognation/fields/Country'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import DateRangePicker from "@/components/app/datetime/DateRangePicker";
  import AppButton from "@/components/app/AppButton";
  import AppSubmit from "@/components/app/AppSubmit";
  import {ECONOMY_BIH, ECONOMY_VIEW_USER, INSTITUTION_USER, INSTITUTION_VIEW_USER, USER_DATA} from "@/shared/constants";
  import {getCountriesList} from "@/services/recognition";
  import {getInstitutionList} from "@/services/institution";
  import {getEconomyList} from "@/services/economy";
  import {getStatusList} from "@/services/applicant";
  import {C_APPLICANT_FILTER_ECONOMY, C_APPLICANT_FILTER_INSTITUTION} from "@/shared/component_permission";
  import i18n from "@/locale";

  export default {
      name: "ApplicantFilter",
      props:{
          loading:{
            type:Boolean,
            default:false
          }
      },
      data(){
          return{
            date:{
              start:null,
              end:null,
            },
            options_decision_recognition:[
              {value:null ,text:'-'},
              {value:1, text: this.$i18n.t("RECOGNIZED")},
              {value:0,text: this.$i18n.t("NOT_RECOGNIZED")}
            ],
            received_for_recognition: [
              {value: null, text: '-'},
              {value: 1, text: i18n.t('SHORT_CYCLE')},
              {value: 2, text: i18n.t('FIRST_CYCLE')},
              {value: 3, text: i18n.t('SECOND_CYCLE')},
              {value: 4, text: i18n.t('THIRD_CYCLE')},
              {value: 5, text: i18n.t('PREGRADUATE')},
              {value: 6, text: i18n.t('GRADUATE')},
              {value: 7, text: i18n.t('POSTGRADUATE')},
              {value: 8, text: i18n.t('OTHER')},
            ],
            decision_type_options:[
              {value: null, text: '-'},
              {value: 1, text: this.$i18n.t('PERMANENT')},
              {value: 2, text: this.$i18n.t('TEMPORARY')},

            ],
            statusList:[],
            filter:{
                institution:null,
                name:null,
                request_protocol_number:null,
                name_of_foreign_qualification:null,
                name_awarding_institution_original_lang:null,
                city_of_institution:null,
                economy:null,
                decision_recognition:null,
                decision_protocol_number:null,
                date_receipt_request_to:null,
                date_receipt_request_from:null,
                status:null,
                study_level:null,
                decision_type:null,
                limit:10,
                page:1

            },
            economyList:[],
            institutionList:[],
            reset_filter:false,
            loader_reset:false,
            loader_submit:false,
            C_APPLICANT_FILTER_ECONOMY,
            C_APPLICANT_FILTER_INSTITUTION
          }
      },
      computed:{
        user(){
          return JSON.parse(localStorage.getItem(USER_DATA))
        },
        visibleTemporaryDecision(){
          return Number(this.user.economy.id) === ECONOMY_BIH
        },
      },
      components:{
        AppSubmit,
        AppButton,
        DateRangePicker,
          Country,
          DatePicker
      },
      methods:{
        dateReceptRequestFrom(value) {
          this.filter.date_receipt_request_from = value
        },
        dateReceptRequestTo(value) {
          this.filter.date_receipt_request_to = value
        },
        search(){
          this.reset_filter = false
          this.$emit('search', this.filter)
        },
        setEconomyList(){
          getEconomyList().then(response => {
            if(!response.data.length){
              return
            }
            this.economyList.push({id:null, name:'-'})
            response.data.forEach(el=>{
              this.economyList.push(el)
            })
          })
        },
        setStatusList(){
            getStatusList().then(response => {
              if(!response.data.length){
                return
              }
             this.statusList.push({id:null, name:'-'})
             response.data.forEach(el=>{
               this.statusList.push(el)
             })

            })
        },
        setInstitutionList(economy){
          this.institutionList = []
          getInstitutionList({economy}).then(response=>{
            if(!response.data.length){
              return
            }
            this.institutionList.push({id:null, name:'-'})
            response.data.forEach(el=>{
              this.institutionList.push(el)
            })
          }, ()=>{
            this.institutionList = []
          })
        },

        resetForm(){

            this.reset_filter = true
            this.filter.name = null,
            this.filter.request_protocol_number = null
            this.filter.name_of_foreign_qualification = null
            this.filter.name_awarding_institution_original_lang = null
            this.filter.country = null
            this.filter.decision_recognition = null
            this.filter.decision_protocol_number = null
            this.filter.date_receipt_request_to = null
            this.filter.date_receipt_request_from = null
            this.filter.status = null
            if(this.user.role.id !== ECONOMY_VIEW_USER){
              this.filter.economy = null
            }
            if(![INSTITUTION_VIEW_USER, INSTITUTION_USER].includes(this.user.role.id)){
              this.filter.institution =  null
            }
            this.filter.study_level = null

          this.$emit('search',this.filter)
        }

      },
      watch:{
        loading:{
          handler(value){
            if(this.reset_filter){
              this.loader_reset = value
            } else {
              this.loader_submit = value
            }
          }
        },
        'filter.economy':{
          handler(value){
            if(!value){
              this.institutionList = []
            }
              this.setInstitutionList(value)

          },deep:true
        }
      },
    created(){
      this.setEconomyList()
      this.setStatusList()
      if(this.user.role.id === INSTITUTION_USER || this.user.role.id === INSTITUTION_VIEW_USER){
        this.filter.institution =  this.user.institution.id
      }
      if(this.user.role.id === ECONOMY_VIEW_USER){
        this.filter.economy = this.user.economy.id
      }
    }
    }
</script>

<style scoped>
  .multiselect__tags {
    min-height: 34px;
    display: block;
    padding: 4px 40px 0 8px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
  }
  label.label-text {
  font-size: 12px;
  }
</style>
